import { CheckType } from '../../../../api/integration-health-client/integration-health-client.type';

const CHECK_TYPE_LABELS: Record<CheckType, string> = {
  [CheckType.NEW_PROJECT]: 'New Project',
  [CheckType.NEW_BOARD]: 'New Board',
  [CheckType.POINTS_FIELD_CHANGED]: 'Points Field Changed',
  [CheckType.FALSE_POSITIVE_DELETION]: 'False Positive Deletion',
  [CheckType.BOARD_NOT_FOUND]: 'Board Not Found',
};

type TableRow = {
  key: string;
  id: string;
  name: string;
  externalIdentifier: string;
  checkType: string;
  resolutionUrl: string;
};

export { CHECK_TYPE_LABELS };
export type { TableRow };
